import { render, staticRenderFns } from "./EqsTabs.vue?vue&type=template&id=71925e02"
import script from "./EqsTabs.vue?vue&type=script&lang=js"
export * from "./EqsTabs.vue?vue&type=script&lang=js"
import style0 from "./EqsTabs.vue?vue&type=style&index=0&id=71925e02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports